
import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';


export default function CopyText({text, children}) {
  const [copied, setCopied] = useState(false);

  const handleCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 800);
  };

  return (
    <Tooltip
      title="Скопировано"
      disableFocusListener
      disableHoverListener
      disableTouchListener
      open={copied}
    >
      <CopyToClipboard text={text} onCopy={handleCopied}><span>{children ? children : text}</span></CopyToClipboard>
    </Tooltip>
  )
}
